export const COMMON_STRING = {
    BLANK: '',
    SUBMIT: 'Submit',
    ERROR: 'error',
    DONE: 'done',
    YES: 'Yes',
    NO: 'No',
};

export const COMMON_NUMBER = {
    LENGTH_ZERO: 0,
    API_SUCCESS: 1,
    API_FAILED: 0,
    VALIDATION_FAILED: 2,
};

export const COMMON_MSG = {
    NO_ANSWER: 'No answer found',
    STILL_WANT_TO_REQ: 'Do you still want to request these changes ?',
};

export const PLACEHOLDER_TEXT = {
    CCI_GPT_SELECT_APPS: 'Please select applications',
    CCI_GPT_SELECT_CATEGORY: 'Please select category',
    CCI_GPT_SELECT_PRIORITY: 'Please select priority',
    CCI_GPT_CUSTOM_QUESTION: 'Type custom question',
    CCI_GPT_SELECT_QUESTION: 'Please select Questions',
};

export const ERROR_MSG = {
    GENERAL_ERROR: 'Something went wrong.',
    UPLOAD_ERROR: 'Error in uploading',
    INVALID_JIRA_TICKET: 'Please enter a valid JIRA ticket number. Example: ENG-123456',
};

export const NOTICATION_MSG = {
    CCI_GPT_SELECT_APPS: 'Atleast select one app.',
    CCI_GPT_SELECT_QUESTION: 'Atleast select one question.',
    CCI_GPT_CUSTOM_QUESTION: 'Question can not be blank.',
};

export const API_METHODS = {
    GET: 'get',
    POST: 'post',
};

export const STATUS_CODE = {
    OK: 200,
};

export const SIZE = {
    SMALL: 'small',
    MEDIUM: 'medium',
    MIDDLE: 'middle',
    LARGE: 'large',
};

export const TYPE_OF = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    OBJECT: 'object', // Array also consider as object
    FUNCTION: 'function',
};

export const NAVIGATION_MENU = {
    CCI_GPT: 'CCI-GPT',
    ML_RESEARCH_PIPELINE: 'ML Research Pipeline',
    MCP_SERVER: 'MCP Server',
};
export const NAVIGATION_MENU_Link = {
    CCI_GPT: '/ccigpt',
    ML_RESEARCH_PIPELINE: '/mlresearchpipeline',
    MCP_SERVER: '/mcpserver',
    MCP_RESEARCH: '/mcpresearch',
};

// ANTD
export const ANTD_COMMON_CSS = {
    JUSTIFY_CENTER: 'center',
};

export const ANTD_SELECT = {
    MODE_MULTI: 'multiple',
    MODE_TAG: 'tags',
};

export const ANTD_SPACE = {
    ALIGN_START: 'start',
    ALIGN_END: 'end',
    ALIGN_CENTER: 'center',
    ALIGN_BASELINE: 'baseline',
    DIRECTION_VERTICAL: 'vertical',
    DIRECTION_HORIZONTAL: 'horizontal',
};

export const ANTD_TEXT = {
    TYPE_SECONDARY: 'secondary',
    TYPE_SUCCESS: 'success',
    TYPE_WARNING: 'warning',
    TYPE_DANGER: 'danger',
};

export const ANTD_BUTTON = {
    TYPE_PRIMARY: 'primary',
    TYPE_LINK: 'link',
    SHAPE_ROUND: 'round',
    SHAPE_CIRCLE: 'circle',
};

export const ANTD_DIVIDER = {
    ORIENTATION_LEFT: 'left',
};

export const COMMON_CSS_PROPERTIES = {
    FONT_SIZE: '12px',
    TITLE_FONT_SIZE: '14px',
    DISPLAY_BLOCK: 'block',
};

export const CCI_GPT_SERVICE_URLs = {
    SEARCH_TEXT: 'search_text',
    SEARCH_URL: 'search_url',
};

export const DASHBOARD_ROLE = {
    ADMIN: 'admin',
    RESEARCH_ADMIN: 'research admin',
    RESEARCHER: 'researcher',
    REVIEWER: 'reviewer',
    GUEST: 'Guest',
    REPORT: 'report user',
};

export const FAV_ICON_PRE_URL = 'http://www.google.com/s2/favicons?domain=';

export const BitOptions = [
    { label: '-1', value: -1 },
    { label: '0', value: 0 },
    { label: '1', value: 1 },
];

export const COMMON_REGEX = {
    JIRA_TICKET: /^(ENG-)\d{6,7}$/i,
};
